var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Tooltip, Typography } from "@mui/material";
import { useEffect, useRef, useState } from "react";
import { commonTooltipProps } from "../../Utils";
export const TypographyWithTooltipOnOverflow = (props) => {
    const [isOverflow, setIsOverflow] = useState(false);
    const typographyRef = useRef(null);
    const { multiline, TooltipProps } = props, restProps = __rest(props, ["multiline", "TooltipProps"]);
    const compareSize = () => {
        var _a, _b, _c, _d;
        setIsOverflow(multiline
            ? ((_a = typographyRef.current) === null || _a === void 0 ? void 0 : _a.scrollHeight) > ((_b = typographyRef.current) === null || _b === void 0 ? void 0 : _b.offsetHeight)
            : ((_c = typographyRef.current) === null || _c === void 0 ? void 0 : _c.scrollWidth) > ((_d = typographyRef.current) === null || _d === void 0 ? void 0 : _d.clientWidth));
    };
    // Add resize listener on "componentDidMount"
    useEffect(() => {
        window.addEventListener("resize", compareSize);
        return () => {
            window.removeEventListener("resize", compareSize);
        };
    }, []);
    useEffect(() => {
        compareSize();
    }, [props.children, props.multiline]);
    return (_jsx(Tooltip, Object.assign({}, commonTooltipProps, { title: restProps.children, disableHoverListener: !isOverflow }, TooltipProps, { children: _jsx(Typography, Object.assign({ noWrap: !multiline }, restProps, { ref: typographyRef })) })));
};
//# sourceMappingURL=TypographyWithTooltipOnOverflow.js.map